import React from "react";
import { useViewport } from "@bookingcom/bui-react";
import { Sidebar } from "../../Container/index.js";
import Frame from "../../Frame/index.js";
import { SkeletonListKeyValue } from "../SkeletonListKeyValue.js";
const SkeletonSearchSidebarDesktop = () => {
    const { isLarge } = useViewport();
    return isLarge ? (React.createElement(Sidebar, null,
        React.createElement(Frame, { p: 4 },
            React.createElement(SkeletonListKeyValue, { amount: 12 })))) : null;
};
export default SkeletonSearchSidebarDesktop;
